var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { action, observable, reaction, runInAction, when } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Notice, Spinner } from 'telia-front-react';
import FieldValueProvider from '../model/FieldValueProvider';
import GravityFormData from '../model/GravityFormData';
import ErrorUtil from '../util/ErrorUtil';
import { FetchStatus } from '../util/FetchStatus';
import { resolveGeopankData } from '../util/GeopankData';
import { serializeForm } from '../util/serializer';
import { withStores } from '../util/StoresProvider';
import Form from './Form';
import { getGravityField, getGravityForm, isFieldDependentOnChangedField, setFieldVisibility, shouldShowField } from './GravityFormFunctions';
import GravityFormSubmitResultModal from './GravityFormSubmitResultModal';
import GravityFormSubmitResultNotice from './GravityFormSubmitResultNotice';
let GravityForm = (() => {
    var _GravityForm_inModal_accessor_storage, _GravityForm_ref_accessor_storage, _GravityForm_submitting_accessor_storage, _GravityForm_submitSuccess_accessor_storage, _GravityForm_submitFailure_accessor_storage, _GravityForm_confirmationMessage_accessor_storage, _GravityForm_isInitialized_accessor_storage, _GravityForm_captcha_accessor_storage, _GravityForm_auth_accessor_storage, _GravityForm_gravityFormStore_accessor_storage, _GravityForm_fieldValidationStore_accessor_storage, _GravityForm_valueStore_accessor_storage, _GravityForm_app_accessor_storage, _GravityForm_form_accessor_storage;
    let _classDecorators = [observer];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = React.Component;
    let _instanceExtraInitializers = [];
    let _inModal_decorators;
    let _inModal_initializers = [];
    let _inModal_extraInitializers = [];
    let _ref_decorators;
    let _ref_initializers = [];
    let _ref_extraInitializers = [];
    let _submitting_decorators;
    let _submitting_initializers = [];
    let _submitting_extraInitializers = [];
    let _submitSuccess_decorators;
    let _submitSuccess_initializers = [];
    let _submitSuccess_extraInitializers = [];
    let _submitFailure_decorators;
    let _submitFailure_initializers = [];
    let _submitFailure_extraInitializers = [];
    let _confirmationMessage_decorators;
    let _confirmationMessage_initializers = [];
    let _confirmationMessage_extraInitializers = [];
    let _isInitialized_decorators;
    let _isInitialized_initializers = [];
    let _isInitialized_extraInitializers = [];
    let _captcha_decorators;
    let _captcha_initializers = [];
    let _captcha_extraInitializers = [];
    let _auth_decorators;
    let _auth_initializers = [];
    let _auth_extraInitializers = [];
    let _gravityFormStore_decorators;
    let _gravityFormStore_initializers = [];
    let _gravityFormStore_extraInitializers = [];
    let _fieldValidationStore_decorators;
    let _fieldValidationStore_initializers = [];
    let _fieldValidationStore_extraInitializers = [];
    let _valueStore_decorators;
    let _valueStore_initializers = [];
    let _valueStore_extraInitializers = [];
    let _app_decorators;
    let _app_initializers = [];
    let _app_extraInitializers = [];
    let _form_decorators;
    let _form_initializers = [];
    let _form_extraInitializers = [];
    let _touchFields_decorators;
    let _initiateConditionalLogic_decorators;
    var GravityForm = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            Object.defineProperty(this, "disposers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (__runInitializers(this, _instanceExtraInitializers), [])
            });
            _GravityForm_inModal_accessor_storage.set(this, __runInitializers(this, _inModal_initializers, false));
            _GravityForm_ref_accessor_storage.set(this, (__runInitializers(this, _inModal_extraInitializers), __runInitializers(this, _ref_initializers, null)));
            _GravityForm_submitting_accessor_storage.set(this, (__runInitializers(this, _ref_extraInitializers), __runInitializers(this, _submitting_initializers, false)));
            _GravityForm_submitSuccess_accessor_storage.set(this, (__runInitializers(this, _submitting_extraInitializers), __runInitializers(this, _submitSuccess_initializers, false)));
            _GravityForm_submitFailure_accessor_storage.set(this, (__runInitializers(this, _submitSuccess_extraInitializers), __runInitializers(this, _submitFailure_initializers, false)));
            _GravityForm_confirmationMessage_accessor_storage.set(this, (__runInitializers(this, _submitFailure_extraInitializers), __runInitializers(this, _confirmationMessage_initializers, void 0)));
            _GravityForm_isInitialized_accessor_storage.set(this, (__runInitializers(this, _confirmationMessage_extraInitializers), __runInitializers(this, _isInitialized_initializers, void 0)));
            _GravityForm_captcha_accessor_storage.set(this, (__runInitializers(this, _isInitialized_extraInitializers), __runInitializers(this, _captcha_initializers, void 0)));
            _GravityForm_auth_accessor_storage.set(this, (__runInitializers(this, _captcha_extraInitializers), __runInitializers(this, _auth_initializers, void 0)));
            _GravityForm_gravityFormStore_accessor_storage.set(this, (__runInitializers(this, _auth_extraInitializers), __runInitializers(this, _gravityFormStore_initializers, void 0)));
            _GravityForm_fieldValidationStore_accessor_storage.set(this, (__runInitializers(this, _gravityFormStore_extraInitializers), __runInitializers(this, _fieldValidationStore_initializers, void 0)));
            _GravityForm_valueStore_accessor_storage.set(this, (__runInitializers(this, _fieldValidationStore_extraInitializers), __runInitializers(this, _valueStore_initializers, void 0)));
            _GravityForm_app_accessor_storage.set(this, (__runInitializers(this, _valueStore_extraInitializers), __runInitializers(this, _app_initializers, void 0)));
            _GravityForm_form_accessor_storage.set(this, (__runInitializers(this, _app_extraInitializers), __runInitializers(this, _form_initializers, void 0)));
            Object.defineProperty(this, "gravityForm", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: __runInitializers(this, _form_extraInitializers)
            });
            Object.defineProperty(this, "addDisposer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (disposer) => {
                    this.disposers.push(disposer);
                }
            });
            Object.defineProperty(this, "handleSubmit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    runInAction(() => {
                        this.fieldValidationStore.clearErroredFields();
                        if (this.form !== null && !this.form.isValid) {
                            this.touchFields();
                        }
                        if (!this.submitting && this.form !== null && this.form.isValid && !this.props.outsideDataInvalid) {
                            this.submitForm();
                        }
                    });
                }
            });
            Object.defineProperty(this, "handleSubmitSuccess", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (response) => {
                    runInAction(() => {
                        this.redirectIfNeeded();
                        this.submitSuccess = true;
                        this.submitting = false;
                        if (this.props.onSubmitSuccess) {
                            this.props.onSubmitSuccess();
                        }
                        this.confirmationMessage = response.data.confirmationMessage;
                        if (!this.inModal) {
                            this.props.gravityFormStore.toggleFormSubmitResultModal(true);
                        }
                        this.pushGaData(response.data.submissionId);
                    });
                }
            });
            Object.defineProperty(this, "handleSubmitCallbacks", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    if (this.form.sendSubmitToGeopank) {
                        this.props.gravityFormStore.submitGeopankData(resolveGeopankData(this.form));
                    }
                    if (this.props.submitSuccessCallback) {
                        return this.props.submitSuccessCallback(this.form);
                    }
                    return Promise.resolve();
                }
            });
            Object.defineProperty(this, "handleSubmitFailure", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (error) => {
                    ErrorUtil.pushErrorToTeliaRumAndLog(error);
                    runInAction(() => {
                        this.submitting = false;
                        this.submitFailure = true;
                        if (!this.inModal) {
                            this.props.gravityFormStore.toggleFormSubmitResultModal(true);
                        }
                        if (this.props.onSubmitFailure) {
                            this.props.onSubmitFailure();
                        }
                    });
                }
            });
            Object.defineProperty(this, "setRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (el) => {
                    runInAction(() => {
                        this.ref = el;
                        if (el) {
                            this.inModal = this.ref.closest('.modal') !== null;
                        }
                    });
                }
            });
            Object.defineProperty(this, "setCaptchaCallback", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (captcha) => {
                    runInAction(() => {
                        this.captcha = captcha;
                    });
                }
            });
        }
        get inModal() { return __classPrivateFieldGet(this, _GravityForm_inModal_accessor_storage, "f"); }
        set inModal(value) { __classPrivateFieldSet(this, _GravityForm_inModal_accessor_storage, value, "f"); }
        get ref() { return __classPrivateFieldGet(this, _GravityForm_ref_accessor_storage, "f"); }
        set ref(value) { __classPrivateFieldSet(this, _GravityForm_ref_accessor_storage, value, "f"); }
        get submitting() { return __classPrivateFieldGet(this, _GravityForm_submitting_accessor_storage, "f"); }
        set submitting(value) { __classPrivateFieldSet(this, _GravityForm_submitting_accessor_storage, value, "f"); }
        get submitSuccess() { return __classPrivateFieldGet(this, _GravityForm_submitSuccess_accessor_storage, "f"); }
        set submitSuccess(value) { __classPrivateFieldSet(this, _GravityForm_submitSuccess_accessor_storage, value, "f"); }
        get submitFailure() { return __classPrivateFieldGet(this, _GravityForm_submitFailure_accessor_storage, "f"); }
        set submitFailure(value) { __classPrivateFieldSet(this, _GravityForm_submitFailure_accessor_storage, value, "f"); }
        get confirmationMessage() { return __classPrivateFieldGet(this, _GravityForm_confirmationMessage_accessor_storage, "f"); }
        set confirmationMessage(value) { __classPrivateFieldSet(this, _GravityForm_confirmationMessage_accessor_storage, value, "f"); }
        get isInitialized() { return __classPrivateFieldGet(this, _GravityForm_isInitialized_accessor_storage, "f"); }
        set isInitialized(value) { __classPrivateFieldSet(this, _GravityForm_isInitialized_accessor_storage, value, "f"); }
        get captcha() { return __classPrivateFieldGet(this, _GravityForm_captcha_accessor_storage, "f"); }
        set captcha(value) { __classPrivateFieldSet(this, _GravityForm_captcha_accessor_storage, value, "f"); }
        get auth() { return __classPrivateFieldGet(this, _GravityForm_auth_accessor_storage, "f"); }
        set auth(value) { __classPrivateFieldSet(this, _GravityForm_auth_accessor_storage, value, "f"); }
        get gravityFormStore() { return __classPrivateFieldGet(this, _GravityForm_gravityFormStore_accessor_storage, "f"); }
        set gravityFormStore(value) { __classPrivateFieldSet(this, _GravityForm_gravityFormStore_accessor_storage, value, "f"); }
        get fieldValidationStore() { return __classPrivateFieldGet(this, _GravityForm_fieldValidationStore_accessor_storage, "f"); }
        set fieldValidationStore(value) { __classPrivateFieldSet(this, _GravityForm_fieldValidationStore_accessor_storage, value, "f"); }
        get valueStore() { return __classPrivateFieldGet(this, _GravityForm_valueStore_accessor_storage, "f"); }
        set valueStore(value) { __classPrivateFieldSet(this, _GravityForm_valueStore_accessor_storage, value, "f"); }
        get app() { return __classPrivateFieldGet(this, _GravityForm_app_accessor_storage, "f"); }
        set app(value) { __classPrivateFieldSet(this, _GravityForm_app_accessor_storage, value, "f"); }
        get form() { return __classPrivateFieldGet(this, _GravityForm_form_accessor_storage, "f"); }
        set form(value) { __classPrivateFieldSet(this, _GravityForm_form_accessor_storage, value, "f"); }
        componentDidMount() {
            this.gravityFormStore = this.props.gravityFormStore;
            this.fieldValidationStore = this.props.fieldValidationStore;
            this.isInitialized = this.props.gravityFormStore.isInitialized;
            this.fieldValidationStore.setShouldHideNoticeInHeader(this.props.hideErrorNoticeInHeader);
            this.app = this.props.gravityFormStore.app;
            this.auth = this.props.clientAuth;
            this.addDisposer(when(() => this.isInitialized, () => this.loadForm()));
            this.addDisposer(reaction(() => this.auth, () => this.updatePrefilledValues()));
            this.addDisposer(reaction(() => this.gravityFormStore.isInitialized, () => {
                this.isInitialized = this.gravityFormStore.isInitialized;
            }));
        }
        componentDidUpdate(prevProps) {
            if (prevProps.clientAuth !== this.props.clientAuth) {
                this.auth = this.props.clientAuth;
            }
            if (this.valueStore && JSON.stringify(this.valueStore.providers) !== JSON.stringify(this.props.fieldValueProviders)) {
                this.valueStore.mapFieldDataFromProviders({ form: this.gravityForm, providers: this.props.fieldValueProviders });
                this.form.updateValueProviderForFieldData(this.valueStore);
            }
        }
        componentWillUnmount() {
            this.disposers.forEach((disposer) => disposer());
            this.fieldValidationStore.clearErroredFields();
        }
        loadForm() {
            const { gravityFormStore, name } = this.props;
            this.gravityForm = gravityFormStore.getForm(name);
            if (this.gravityForm) {
                if (!this.gravityForm.isInitialized) {
                    this.gravityForm.fetch(this.app);
                }
                this.addDisposer(when(() => this.gravityForm.isInitialized, () => this.setForm(this.gravityForm)));
            }
        }
        async setForm(gravityForm) {
            const { formPrefilledDataStore, cmsDataStore, fieldValueProviders } = this.props;
            const valueStoreParams = {
                dataStore: cmsDataStore,
                providers: fieldValueProviders,
                form: gravityForm,
                registerDisposer: this.addDisposer
            };
            if (fieldValueProviders || gravityForm.fields.find((field) => field.technicalParameter !== null)) {
                await formPrefilledDataStore.getContactInfo();
                this.updatePrefilledValues();
                runInAction(() => {
                    this.valueStore = new FieldValueProvider(valueStoreParams);
                });
            }
            runInAction(() => {
                this.form = new GravityFormData(gravityForm, this.valueStore);
            });
            formPrefilledDataStore.mapPrefilledValuesFromQueryStrings(getGravityForm(this.form));
            this.initiateConditionalLogic();
        }
        async updatePrefilledValues() {
            var _a, _b, _c;
            const prefilledCustomerId = (_a = this.props.decodedParams) === null || _a === void 0 ? void 0 : _a.customer_id;
            if (prefilledCustomerId && `${(_c = (_b = this.props.clientAuth) === null || _b === void 0 ? void 0 : _b.customer) === null || _c === void 0 ? void 0 : _c.customerId}` !== `${prefilledCustomerId}`) {
                return;
            }
            this.props.formPrefilledDataStore.clearTechnicalParameters();
            await this.props.formPrefilledDataStore.getContactInfo();
            this.gravityForm.fields.forEach((field) => field.technicalParameter !== null ? this.props.formPrefilledDataStore.mapPrefilledValues(field.technicalParameter) : null);
        }
        submitForm() {
            this.submitFailure = false;
            this.submitting = true;
            const submitPayload = serializeForm(this.form);
            submitPayload.prefilledCustomerId = this.form.prefilledCustomerId;
            submitPayload.captcha = this.captcha;
            this.props.gravityFormStore
                .submitForm(this.form.id, submitPayload)
                .then(this.handleSubmitSuccess)
                .then(this.handleSubmitCallbacks)
                .catch(this.handleSubmitFailure);
        }
        pushGaData(submissionId) {
            if (!!submissionId) {
                const { submissionCustomGaData, name, gaDataStore } = this.props;
                gaDataStore.push({
                    event: (submissionCustomGaData === null || submissionCustomGaData === void 0 ? void 0 : submissionCustomGaData.event) || 'AutoEvent',
                    eventCategory: (submissionCustomGaData === null || submissionCustomGaData === void 0 ? void 0 : submissionCustomGaData.eventCategory) || gaDataStore.getPageTitle(),
                    eventAction: (submissionCustomGaData === null || submissionCustomGaData === void 0 ? void 0 : submissionCustomGaData.eventAction) || 'Form',
                    eventLabel: `Form Submit - ${name}${!!(submissionCustomGaData === null || submissionCustomGaData === void 0 ? void 0 : submissionCustomGaData.eventLabel) ? ` - ${submissionCustomGaData.eventLabel}` : ''}`,
                    submissionId
                });
            }
        }
        touchFields() {
            this.form.fields.forEach((field) => {
                field.onSubmit();
                if (field.isMissing || field.hasError) {
                    this.fieldValidationStore.addToErroredFields(`field-${field.id}`, field.label);
                }
            });
        }
        redirectIfNeeded() {
            const redirect = this.form.confirmations.find((confirm) => confirm.default && !!confirm.url);
            if (redirect) {
                this.props.navigate(redirect.url);
            }
        }
        onChangeCallback(changedField) {
            const changedGravityField = getGravityField(changedField);
            const gravityForm = getGravityForm(this.form);
            gravityForm.fields
                .map(getGravityField)
                .filter((field) => isFieldDependentOnChangedField(field, changedGravityField))
                .forEach((dependentField) => setFieldVisibility(dependentField, shouldShowField(dependentField, gravityForm)));
        }
        initiateConditionalLogic() {
            const gravityForm = getGravityForm(this.form);
            const gravityFields = gravityForm.fields.map(getGravityField);
            gravityFields.forEach((field) => setFieldVisibility(field, shouldShowField(field, gravityForm)));
        }
        render() {
            var _a;
            const { showTitle, showDescription, sections, backButtonProps, infoPdfButtonProps, submitButtonProps, language, gridColumnProps, buttonGridProps, translateStore: { translationsFetchStatus, translate }, gravityFormStore } = this.props;
            if (gravityFormStore.hasError || ((_a = this.gravityForm) === null || _a === void 0 ? void 0 : _a.hasError)) {
                return React.createElement(Notice, { type: "error" }, translate('general.error.message'));
            }
            if (!this.form || translationsFetchStatus !== FetchStatus.FETCHED) {
                return React.createElement(Spinner, null);
            }
            if (this.submitSuccess) {
                return !this.inModal ? (React.createElement(GravityFormSubmitResultModal, { hasError: false, modalContent: this.confirmationMessage })) : (React.createElement(GravityFormSubmitResultNotice, { hasError: false, modalContent: this.confirmationMessage, onClose: () => { var _a, _b; return (_b = (_a = this.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a); } }));
            }
            if (this.submitFailure) {
                return !this.inModal ? (React.createElement(GravityFormSubmitResultModal, { hasError: true })) : (React.createElement(GravityFormSubmitResultNotice, { hasError: true, onClose: () => { var _a, _b; return (_b = (_a = this.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a); } }));
            }
            const onChangeCallback = this.onChangeCallback.bind(this);
            return (React.createElement(Form, { form: this.form, submitting: this.submitting, submitFailed: this.submitFailure, showTitle: showTitle, showDescription: showDescription, submit: this.handleSubmit, onChangeCallback: onChangeCallback, setCaptcha: this.setCaptchaCallback, sections: sections, backButtonProps: backButtonProps, infoPdfButtonProps: infoPdfButtonProps, submitButtonProps: submitButtonProps, currentLanguage: language, gridColumnProps: gridColumnProps, buttonGridProps: buttonGridProps, setRef: this.setRef }));
        }
    };
    _GravityForm_inModal_accessor_storage = new WeakMap();
    _GravityForm_ref_accessor_storage = new WeakMap();
    _GravityForm_submitting_accessor_storage = new WeakMap();
    _GravityForm_submitSuccess_accessor_storage = new WeakMap();
    _GravityForm_submitFailure_accessor_storage = new WeakMap();
    _GravityForm_confirmationMessage_accessor_storage = new WeakMap();
    _GravityForm_isInitialized_accessor_storage = new WeakMap();
    _GravityForm_captcha_accessor_storage = new WeakMap();
    _GravityForm_auth_accessor_storage = new WeakMap();
    _GravityForm_gravityFormStore_accessor_storage = new WeakMap();
    _GravityForm_fieldValidationStore_accessor_storage = new WeakMap();
    _GravityForm_valueStore_accessor_storage = new WeakMap();
    _GravityForm_app_accessor_storage = new WeakMap();
    _GravityForm_form_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "GravityForm");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _inModal_decorators = [observable];
        _ref_decorators = [observable];
        _submitting_decorators = [observable];
        _submitSuccess_decorators = [observable];
        _submitFailure_decorators = [observable];
        _confirmationMessage_decorators = [observable];
        _isInitialized_decorators = [observable];
        _captcha_decorators = [observable];
        _auth_decorators = [observable];
        _gravityFormStore_decorators = [observable];
        _fieldValidationStore_decorators = [observable];
        _valueStore_decorators = [observable];
        _app_decorators = [observable];
        _form_decorators = [observable];
        _touchFields_decorators = [action];
        _initiateConditionalLogic_decorators = [action];
        __esDecorate(_classThis, null, _inModal_decorators, { kind: "accessor", name: "inModal", static: false, private: false, access: { has: obj => "inModal" in obj, get: obj => obj.inModal, set: (obj, value) => { obj.inModal = value; } }, metadata: _metadata }, _inModal_initializers, _inModal_extraInitializers);
        __esDecorate(_classThis, null, _ref_decorators, { kind: "accessor", name: "ref", static: false, private: false, access: { has: obj => "ref" in obj, get: obj => obj.ref, set: (obj, value) => { obj.ref = value; } }, metadata: _metadata }, _ref_initializers, _ref_extraInitializers);
        __esDecorate(_classThis, null, _submitting_decorators, { kind: "accessor", name: "submitting", static: false, private: false, access: { has: obj => "submitting" in obj, get: obj => obj.submitting, set: (obj, value) => { obj.submitting = value; } }, metadata: _metadata }, _submitting_initializers, _submitting_extraInitializers);
        __esDecorate(_classThis, null, _submitSuccess_decorators, { kind: "accessor", name: "submitSuccess", static: false, private: false, access: { has: obj => "submitSuccess" in obj, get: obj => obj.submitSuccess, set: (obj, value) => { obj.submitSuccess = value; } }, metadata: _metadata }, _submitSuccess_initializers, _submitSuccess_extraInitializers);
        __esDecorate(_classThis, null, _submitFailure_decorators, { kind: "accessor", name: "submitFailure", static: false, private: false, access: { has: obj => "submitFailure" in obj, get: obj => obj.submitFailure, set: (obj, value) => { obj.submitFailure = value; } }, metadata: _metadata }, _submitFailure_initializers, _submitFailure_extraInitializers);
        __esDecorate(_classThis, null, _confirmationMessage_decorators, { kind: "accessor", name: "confirmationMessage", static: false, private: false, access: { has: obj => "confirmationMessage" in obj, get: obj => obj.confirmationMessage, set: (obj, value) => { obj.confirmationMessage = value; } }, metadata: _metadata }, _confirmationMessage_initializers, _confirmationMessage_extraInitializers);
        __esDecorate(_classThis, null, _isInitialized_decorators, { kind: "accessor", name: "isInitialized", static: false, private: false, access: { has: obj => "isInitialized" in obj, get: obj => obj.isInitialized, set: (obj, value) => { obj.isInitialized = value; } }, metadata: _metadata }, _isInitialized_initializers, _isInitialized_extraInitializers);
        __esDecorate(_classThis, null, _captcha_decorators, { kind: "accessor", name: "captcha", static: false, private: false, access: { has: obj => "captcha" in obj, get: obj => obj.captcha, set: (obj, value) => { obj.captcha = value; } }, metadata: _metadata }, _captcha_initializers, _captcha_extraInitializers);
        __esDecorate(_classThis, null, _auth_decorators, { kind: "accessor", name: "auth", static: false, private: false, access: { has: obj => "auth" in obj, get: obj => obj.auth, set: (obj, value) => { obj.auth = value; } }, metadata: _metadata }, _auth_initializers, _auth_extraInitializers);
        __esDecorate(_classThis, null, _gravityFormStore_decorators, { kind: "accessor", name: "gravityFormStore", static: false, private: false, access: { has: obj => "gravityFormStore" in obj, get: obj => obj.gravityFormStore, set: (obj, value) => { obj.gravityFormStore = value; } }, metadata: _metadata }, _gravityFormStore_initializers, _gravityFormStore_extraInitializers);
        __esDecorate(_classThis, null, _fieldValidationStore_decorators, { kind: "accessor", name: "fieldValidationStore", static: false, private: false, access: { has: obj => "fieldValidationStore" in obj, get: obj => obj.fieldValidationStore, set: (obj, value) => { obj.fieldValidationStore = value; } }, metadata: _metadata }, _fieldValidationStore_initializers, _fieldValidationStore_extraInitializers);
        __esDecorate(_classThis, null, _valueStore_decorators, { kind: "accessor", name: "valueStore", static: false, private: false, access: { has: obj => "valueStore" in obj, get: obj => obj.valueStore, set: (obj, value) => { obj.valueStore = value; } }, metadata: _metadata }, _valueStore_initializers, _valueStore_extraInitializers);
        __esDecorate(_classThis, null, _app_decorators, { kind: "accessor", name: "app", static: false, private: false, access: { has: obj => "app" in obj, get: obj => obj.app, set: (obj, value) => { obj.app = value; } }, metadata: _metadata }, _app_initializers, _app_extraInitializers);
        __esDecorate(_classThis, null, _form_decorators, { kind: "accessor", name: "form", static: false, private: false, access: { has: obj => "form" in obj, get: obj => obj.form, set: (obj, value) => { obj.form = value; } }, metadata: _metadata }, _form_initializers, _form_extraInitializers);
        __esDecorate(_classThis, null, _touchFields_decorators, { kind: "method", name: "touchFields", static: false, private: false, access: { has: obj => "touchFields" in obj, get: obj => obj.touchFields }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _initiateConditionalLogic_decorators, { kind: "method", name: "initiateConditionalLogic", static: false, private: false, access: { has: obj => "initiateConditionalLogic" in obj, get: obj => obj.initiateConditionalLogic }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        GravityForm = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return GravityForm = _classThis;
})();
const component = inject('gravityFormStore', 'fieldValidationStore', 'cmsDataStore', 'gaDataStore', 'formPrefilledDataStore', 'ssoStore', 'translateStore')(GravityForm);
export default withStores(component);
//# sourceMappingURL=GravityForm.js.map